function shallowEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
}

function deepEqual(a, b) {
  if (a === b) return true;                       // handles primitives, same refs, also -0/+0 correctly
  if (a == null || b == null) return a === b;     // null/undefined cases

  // Handle Dates
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  // Handle RegExps
  if (a instanceof RegExp && b instanceof RegExp) {
    return a.source === b.source && a.flags === b.flags;
  }

  // Handle NaN
  if (typeof a === 'number' && typeof b === 'number') {
    return Number.isNaN(a) && Number.isNaN(b);
  }

  // If types differ or one isn't object-like, fail
  if (typeof a !== 'object' || typeof b !== 'object') return false;

  // Arrays vs non-arrays
  const aIsArr = Array.isArray(a);
  const bIsArr = Array.isArray(b);
  if (aIsArr !== bIsArr) return false;

  // Compare keys (for arrays, these are indices for present elements)
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  // Ensure same keys, then recurse
  for (const k of keysA) {
    if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
    if (!deepEqual(a[k], b[k])) return false;
  }

  return true;
}

function deepSet(object1, path, value) {
  const keys = path.split('.');
    let current = object1;

    // Traverse the path and create objects if necessary
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!current[key]) current[key] = {}; // Create the nested object if it doesn't exist
        current = current[key];
    }

    // Set the value at the deepest level
    current[keys[keys.length - 1]] = value;
}

function isObject(object) {
  return object != null && typeof object === "object";
}

export { shallowEqual, deepEqual, deepSet, isObject };
